module.exports = __webpack_public_path__ + "media/images/official/kv_pc1-e109f370aeaa9fb26258ca094a757891.webp";